"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.edit = edit;
exports.getBigCatTagsSortList = getBigCatTagsSortList;

var _request = _interopRequireDefault(require("@/utils/request"));

function edit(data) {
  return (0, _request.default)({
    url: 'set-big-cat-tags-sort-list',
    method: 'post',
    data: data
  });
}

function getBigCatTagsSortList(params) {
  return (0, _request.default)({
    url: 'get-big-cat-tags-sort-list',
    method: 'get',
    params: params
  });
}